import type { MaybeComputedElementRef } from "@vueuse/core";
import type { MaybeRefOrGetter } from "vue";
import { useElementSize, useScroll } from "@vueuse/core";
import { toValue, watch } from "vue";

interface UseAutoScrollOptions {
  deep?: boolean;
  behavior?: ScrollBehavior;
}

export function useChatAutoScroll(containerRef: MaybeComputedElementRef<HTMLElement | null>, deps: MaybeRefOrGetter, options: UseAutoScrollOptions = {}) {
  const { arrivedState } = useScroll(containerRef);

  function scrollToBottom({ behavior }: { behavior?: ScrollBehavior } = {}) {
    const el = toValue(containerRef) as HTMLElement | null;
    if (el) {
      el.scrollTo({ top: el.scrollHeight, behavior: behavior ?? options?.behavior });
    }
  }

  // keep it scrolled to the bottom if container resizes
  const { width, height } = useElementSize(containerRef);
  watch([width, height], () => {
    if (arrivedState.bottom) {
      scrollToBottom({ behavior: "instant" });
    }
  });

  watch(deps, async () => {
    // only autoscroll if user is at the bottom
    if (arrivedState.bottom) {
      scrollToBottom();
    }
  }, {
    deep: options?.deep,
    flush: "post",
  });
}
